<template>
  <v-container>
    <v-row>
      <v-col>
        <h2 class="font-weight-light pb-2">Copy playlist - {{ playlist.name }}</h2>
        <p v-html="playlistCopyText"></p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-right">
        <v-btn
        v-if="!copyButtonPressed"
        :disabled="isUpdating"
        outlined
        :color="playlist.default_color"
        dark
        @click="copyCourse">
          Copy Playlist
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-progress-linear
          :active="isUpdating"
          :color="playlist.default_color"
          indeterminate
        ></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* global dataLayer */
import {
  mapState,
  mapMutations,
  mapActions,
} from 'vuex';
import _ from 'lodash';

export default {
  name: 'PlaylistCopy',
  components: {
  },
  data: () => ({
    copyButtonPressed: false,
  }),
  computed: {
    ...mapState([
      'alreadyCopied',
      'copiedPlaylistHash',
      'isUpdating',
      'playlist',
      'playlistId',
      'user',
    ]),
    playlistCopyText() {
      return `Preview the playlist using the toggle above.  When you are ready to create a copy of this playlist attached to your user account, click the button below.
      ${_.get(this.playlist, 'config.sku', false) ? '<br>Note: Copied playlists with a paywall have restrictions on add/removing content and on changing settings.' : ''}`;
    },
  },
  methods: {
    ...mapMutations([
      'toggleSnackbar',
    ]),
    ...mapActions([
      'copyCoursePlaylist',
    ]),
    async copyCourse() {
      this.copyButtonPressed = true;
      await this.copyCoursePlaylist();
      if (this.alreadyCopied) {
        this.newBlueScreenRedirect({
          title: 'Course Already Copied',
          subtitle: 'Please access your playlist through your dash or through the URL below.',
          text: `https://www.playposit.com/course/${this.copiedPlaylistHash}`,
          buttons: [
            {
              text: 'Launch Playlist',
              action: () => {
                this.$router.replace({ path: `/course/${this.copiedPlaylistHash}` });
                window.location.reload();
              },
              order: 0,
            },
          ],
        });
      } else {
        this.$router.replace({ path: `/course/${this.copiedPlaylistHash}` });
        window.location.reload();
      }
    },
    newBlueScreenRedirect(props) {
      this.$enablePlaypositErrorScreen({
        vertical: true,
        active_color: '#2196F3',
        base_color: '#0d47a1',
        inactive_color: '#757575',
        title: _.has(props, 'title') ? props.title : 'Error',
        subtitle: _.has(props, 'subtitle') ? props.subtitle : 'Sorry, something has gone wrong.',
        code: _.has(props, 'code') ? props.code : '',
        text: _.has(props, 'text') ? props.text : '',
        icon: _.has(props, 'icon') ? props.icon : 'error',
        buttons: _.has(props, 'buttons') ? props.buttons : [],
      });
      dataLayer.errorLog(props);
    },
  },
  created() {
    if (
      !_.get(this.user, 'school.config.permissions', []).includes('hasPlaylistAccess')
      && !_.get(this.playlist, 'config.sku')
    ) {
      this.newBlueScreenRedirect({
        title: 'Access Denied',
        subtitle: 'You do not have access to this feature.',
        icon: 'pan_tool',
        text: 'Please contact your account manager about adding access to Playlists.',
      });
    }
  },
};
</script>
